"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabasesGridSortProvider = exports.DatabasesDefaultSortField = exports.DatabasesDefaultDirections = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../../gen-src/queries");
exports.DatabasesDefaultDirections = (_a = {},
    _a[queries_1.DatabaseOrderField.NAME] = queries_1.OrderDirection.ASC,
    _a[queries_1.DatabaseOrderField.DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT] = queries_1.OrderDirection.DESC,
    _a[queries_1.DatabaseOrderField.DOWNSTREAM_DATASOURCES_COUNT] = queries_1.OrderDirection.DESC,
    _a[queries_1.DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT] = queries_1.OrderDirection.DESC,
    _a[queries_1.DatabaseOrderField.CONNECTION_TYPE] = queries_1.OrderDirection.ASC,
    _a[queries_1.DatabaseOrderField.IS_CERTIFIED] = queries_1.OrderDirection.DESC,
    _a);
exports.DatabasesDefaultSortField = queries_1.DatabaseOrderField.DOWNSTREAM_WORKBOOKS_COUNT;
function DatabasesGridSortProvider(props) {
    return (react_1.default.createElement(data_catalog_shared_1.UrlSortProvider, { validOrderFieldsWithDefaultDirections: exports.DatabasesDefaultDirections, defaultField: exports.DatabasesDefaultSortField }, props.children));
}
exports.DatabasesGridSortProvider = DatabasesGridSortProvider;
//# sourceMappingURL=DatabasesGridSortProvider.js.map